import { formatCents } from './pnl'

/** GET /confirm-phrase: the phrase plus schedule_campaign's list-health figures for the same cohort. */
export type ConfirmCheck = {
  confirm_phrase: string
  /** Fraction of the addresses with a validation result; null when the cohort has no addresses. */
  validation_coverage: number | null
  undeliverable_rate: number | null
  min_validation_coverage: number
  max_undeliverable_rate: number
}

// Rounded down to a tenth of a percent, so 89.96% never reads as 90%.
const pct = (x: number): string => `${Math.floor(Math.round(x * 10000) / 10) / 10}%`

/** What the approve dialog warns about before the operator types the phrase. */
export function approvalWarnings(check: ConfirmCheck | undefined, budgetCents: number | null,
  expectedCostCents: number | null | undefined): string[] {
  const out: string[] = []
  if (check?.validation_coverage != null && check.validation_coverage < check.min_validation_coverage) {
    out.push(`Approval will be refused: only ${pct(check.validation_coverage)} of these addresses have been verified `
      + `(at least ${pct(check.min_validation_coverage)} must be). Run an email verification first.`)
  }
  if (check?.undeliverable_rate != null && check.undeliverable_rate > check.max_undeliverable_rate) {
    out.push(`Approval will be refused: ${pct(check.undeliverable_rate)} of these addresses are undeliverable `
      + `(at most ${pct(check.max_undeliverable_rate)} is allowed).`)
  }
  if (budgetCents != null && expectedCostCents != null && budgetCents < expectedCostCents) {
    out.push(`This budget is below the expected cost of ${formatCents(expectedCostCents)}; `
      + 'sending will pause when the budget runs out.')
  }
  return out
}
